/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MachineSaleListModel
 */
export interface MachineSaleListModel {
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListModel
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    category?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListModel
     */
    categoryId?: number;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    subCategory?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListModel
     */
    subCategoryId?: number;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    brand?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    modelName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListModel
     */
    price?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListModel
     */
    photoId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    brandName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    modelYear?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    productionYear?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    operatingWeight?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    operatingHeight?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    operationHour?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    operationMileage?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    maxLoadCapacity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    maxHeight?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    nominalCapacity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    carryingCapacity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    enginePower?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    fuelType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    bomLength?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    maxPower?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    minPower?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    spraySpeed?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    tankVolume?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    volume?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    flightTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    cameraResolution?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineSaleListModel
     */
    saleAdTitle?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MachineSaleListModel
     */
    hasOperator?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListModel
     */
    rank?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineSaleListModel
     */
    cityId?: number | null;
}

export function MachineSaleListModelFromJSON(json: any): MachineSaleListModel {
    return MachineSaleListModelFromJSONTyped(json, false);
}

export function MachineSaleListModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachineSaleListModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'category': !exists(json, 'category') ? undefined : json['category'],
        'categoryId': !exists(json, 'categoryId') ? undefined : json['categoryId'],
        'subCategory': !exists(json, 'subCategory') ? undefined : json['subCategory'],
        'subCategoryId': !exists(json, 'subCategoryId') ? undefined : json['subCategoryId'],
        'brand': !exists(json, 'brand') ? undefined : json['brand'],
        'modelName': !exists(json, 'modelName') ? undefined : json['modelName'],
        'price': !exists(json, 'price') ? undefined : json['price'],
        'photoId': !exists(json, 'photoId') ? undefined : json['photoId'],
        'brandName': !exists(json, 'brandName') ? undefined : json['brandName'],
        'modelYear': !exists(json, 'modelYear') ? undefined : json['modelYear'],
        'productionYear': !exists(json, 'productionYear') ? undefined : json['productionYear'],
        'operatingWeight': !exists(json, 'operatingWeight') ? undefined : json['operatingWeight'],
        'operatingHeight': !exists(json, 'operatingHeight') ? undefined : json['operatingHeight'],
        'operationHour': !exists(json, 'operationHour') ? undefined : json['operationHour'],
        'operationMileage': !exists(json, 'operationMileage') ? undefined : json['operationMileage'],
        'maxLoadCapacity': !exists(json, 'maxLoadCapacity') ? undefined : json['maxLoadCapacity'],
        'maxHeight': !exists(json, 'maxHeight') ? undefined : json['maxHeight'],
        'nominalCapacity': !exists(json, 'nominalCapacity') ? undefined : json['nominalCapacity'],
        'carryingCapacity': !exists(json, 'carryingCapacity') ? undefined : json['carryingCapacity'],
        'enginePower': !exists(json, 'enginePower') ? undefined : json['enginePower'],
        'fuelType': !exists(json, 'fuelType') ? undefined : json['fuelType'],
        'bomLength': !exists(json, 'bomLength') ? undefined : json['bomLength'],
        'maxPower': !exists(json, 'maxPower') ? undefined : json['maxPower'],
        'minPower': !exists(json, 'minPower') ? undefined : json['minPower'],
        'spraySpeed': !exists(json, 'spraySpeed') ? undefined : json['spraySpeed'],
        'tankVolume': !exists(json, 'tankVolume') ? undefined : json['tankVolume'],
        'volume': !exists(json, 'volume') ? undefined : json['volume'],
        'flightTime': !exists(json, 'flightTime') ? undefined : json['flightTime'],
        'cameraResolution': !exists(json, 'cameraResolution') ? undefined : json['cameraResolution'],
        'saleAdTitle': !exists(json, 'saleAdTitle') ? undefined : json['saleAdTitle'],
        'hasOperator': !exists(json, 'hasOperator') ? undefined : json['hasOperator'],
        'rank': !exists(json, 'rank') ? undefined : json['rank'],
        'cityId': !exists(json, 'cityId') ? undefined : json['cityId'],
    };
}

export function MachineSaleListModelToJSON(value?: MachineSaleListModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'category': value.category,
        'categoryId': value.categoryId,
        'subCategory': value.subCategory,
        'subCategoryId': value.subCategoryId,
        'brand': value.brand,
        'modelName': value.modelName,
        'price': value.price,
        'photoId': value.photoId,
        'brandName': value.brandName,
        'modelYear': value.modelYear,
        'productionYear': value.productionYear,
        'operatingWeight': value.operatingWeight,
        'operatingHeight': value.operatingHeight,
        'operationHour': value.operationHour,
        'operationMileage': value.operationMileage,
        'maxLoadCapacity': value.maxLoadCapacity,
        'maxHeight': value.maxHeight,
        'nominalCapacity': value.nominalCapacity,
        'carryingCapacity': value.carryingCapacity,
        'enginePower': value.enginePower,
        'fuelType': value.fuelType,
        'bomLength': value.bomLength,
        'maxPower': value.maxPower,
        'minPower': value.minPower,
        'spraySpeed': value.spraySpeed,
        'tankVolume': value.tankVolume,
        'volume': value.volume,
        'flightTime': value.flightTime,
        'cameraResolution': value.cameraResolution,
        'saleAdTitle': value.saleAdTitle,
        'hasOperator': value.hasOperator,
        'rank': value.rank,
        'cityId': value.cityId,
    };
}

